"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";

export function ContactPageHeader() {
    return (
        <section className="pt-10 pb-12 bg-white text-center">
            <div className="container mx-auto px-4">
                <nav className="flex items-center justify-center gap-2 text-sm text-[#666666] mb-6">
                    <Link href="/" className="hover:text-[#2563EB] transition-colors">Home</Link>
                    <ChevronRight size={14} className="text-gray-400" />
                    <span className="text-black">Contact</span>
                </nav>
                <h1 className="text-[#1A1A1A] text-5xl md:text-6xl font-extrabold mb-4">
                    Let's Talk About Your IT Career
                </h1>
                <p className="text-[#666666] text-lg">
                    Whether you have a question about a course, need guidance on which path to take, or want to discuss corporate training options, our team is ready to help.
                </p>
            </div>
        </section>
    );
}
